import React, { useState } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { FileText, Download, Search, Calendar, ChevronDown } from 'lucide-react';

const FacultyBoard2025 = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('all');

  const decisions = [
    {
      id: 1,
      number: 'FKK/10.10.2025',
      date: '2025-10-10',
      title: 'Fakülte Kurulu Kararları (10.10.2025)',
      description: '10 Ekim 2025 tarihli Fakülte Kurulu toplantısında alınan kararlar.',
      month: 'Ekim',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-kurulu/10.10.2025%20Fak%C3%BClte%20Kurulu%20G%C3%BCndemi%20(1).docx'
    },
    {
      id: 2,
      number: 'FKK/19.09.2025',
      date: '2025-09-19',
      title: 'Fakülte Kurulu Kararları (19.09.2025) - 3',
      description: '19 Eylül 2025 tarihli Fakülte Kurulu toplantısında alınan kararlar.',
      month: 'Eylül',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-kurulu/19.09.2025%20-3%20Fak%C3%BClte%20Kurulu%20G%C3%BCndemi.docx'
    },
    {
      id: 3,
      number: 'FKK/21.05.2025',
      date: '2025-05-21',
      title: 'Fakülte Kurulu Kararları (21.05.2025) - 3',
      description: '21 Mayıs 2025 tarihli Fakülte Kurulu toplantısında alınan kararlar.',
      month: 'Mayıs',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-kurulu/21.05.2025%20-%203%20Fak%C3%BClte%20Kurulu%20G%C3%BCndemi%20(2)%20(2).docx'
    },
    {
      id: 4,
      number: 'FKK/26.03.2025',
      date: '2025-03-26',
      title: 'Fakülte Kurulu Kararları (26.03.2025) - 2',
      description: '26 Mart 2025 tarihli Fakülte Kurulu toplantısında alınan kararlar.',
      month: 'Mart',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-kurulu/26.03.2025%20-%202%20%20Fak%C3%BClte%20Kurulu%20G%C3%BCndem.docx'
    }
  ];

  const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
                  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  const filteredDecisions = decisions.filter(decision => {
    const matchesSearch = decision.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         decision.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         decision.number.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesMonth = selectedMonth === 'all' || decision.month === selectedMonth;
    return matchesSearch && matchesMonth;
  });

  return (
    <PageTemplate
      title="2025 Yılı Fakülte Kurulu Kararları"
      breadcrumb={[
        { label: 'Anasayfa', url: '/' },
        { label: 'Fakülte Kararları', url: '/kararlar' },
        { label: 'Fakülte Kurulu Kararları', url: '/kararlar/fakulte-kurulu' },
        { label: '2025' }
      ]}
    >
      <div className="max-w-6xl mx-auto">
        {/* Başlık */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-8 mb-8">
          <div className="flex items-center mb-4">
            <FileText className="w-8 h-8 text-blue-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-800">2025 Yılı Fakülte Kurulu Kararları</h2>
          </div>
          <p className="text-gray-700">
            2025 yılında alınan toplam {decisions.length} adet fakülte kurulu kararını inceleyebilirsiniz.
          </p>
        </div>

        {/* Filtreler */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Arama */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Karar ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
            </div>

            {/* Ay Filtresi */}
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none bg-white"
              >
                <option value="all">Tüm Aylar</option>
                {months.map(month => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
              <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Kararlar Listesi */}
        <div className="space-y-6">
          {filteredDecisions.map((decision) => (
            <div
              key={decision.id}
              className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow p-6"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-3">
                    <span className="bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full">
                      Karar No: {decision.number}
                    </span>
                    <span className="text-gray-500 text-sm">{decision.date}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {decision.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {decision.description}
                  </p>
                </div>
                <div className="ml-6">
                  <a
                    href={decision.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
                  >
                    <Download className="w-4 h-4" />
                    <span>İndir</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sonuç bulunamadı */}
        {filteredDecisions.length === 0 && (
          <div className="text-center py-12">
            <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Karar bulunamadı</h3>
            <p className="text-gray-500">
              Arama kriterlerinize uygun karar bulunmamaktadır. Lütfen farklı terimler deneyin.
            </p>
          </div>
        )}
      </div>
    </PageTemplate>
  );
};

export default FacultyBoard2025;
